export default "__VITE_ASSET__BdD9AFy4__"